import { ICorporatePartner } from './corporate-partner.interface';

export class HipmunkPartner implements ICorporatePartner {
  public name = 'hipmunk';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = true;
  public disableMiles = true;
  public displayInlineText = 'fare';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}
